import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
import routes from './routes'

import 'font-awesome/css/font-awesome.min.css'

import {fromIndex } from './api/api'

import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

import '../src/icons' // icon

Vue.use(VXETable)

Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex)

const router = new VueRouter({
  routes
}) 

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js